import React from "react";
import { useLanguage } from "../../context/LanguageContext";

export const Process = () => {
  const { t } = useLanguage();

  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative py-24 md:py-32 border-t border-slate-800"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-14 md:mb-20">
          <p
            className="text-[11px] tracking-[0.2em] uppercase text-blue-400 mb-5"
            style={{ fontFamily: "'IBM Plex Mono', monospace" }}
          >
            {t.process.overline}
          </p>
          <h2
            className="text-3xl md:text-5xl font-bold tracking-tight text-slate-50 leading-tight"
            style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
            data-testid="process-title"
          >
            {t.process.title}
          </h2>
          <p
            className="mt-5 text-base md:text-lg text-slate-400 max-w-2xl"
            style={{ fontFamily: "'IBM Plex Sans', sans-serif" }}
          >
            {t.process.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border-t border-slate-800">
          {t.process.steps.map((step, i) => (
            <div
              key={i}
              data-testid={`process-step-${i}`}
              className={`group relative py-10 md:py-12 md:px-8 lg:px-10
                ${i !== 0 ? "lg:border-l border-slate-800" : ""}
                ${i !== 0 ? "md:border-t-0" : ""}
                border-b border-slate-800 last:border-b-0 md:border-b-0
              `}
            >
              <p
                className="text-[11px] tracking-[0.25em] uppercase text-slate-500"
                style={{ fontFamily: "'IBM Plex Mono', monospace" }}
              >
                {step.n}
              </p>
              <h3
                className="mt-6 text-lg md:text-xl font-semibold text-slate-50 tracking-tight"
                style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
              >
                {step.title}
              </h3>
              <p
                className="mt-3 text-sm md:text-base text-slate-400 leading-relaxed"
                style={{ fontFamily: "'IBM Plex Sans', sans-serif" }}
              >
                {step.desc}
              </p>
              <div className="absolute top-10 right-6 md:right-8 w-2 h-2 bg-blue-500/0 group-hover:bg-blue-500 transition-colors duration-300" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
